<template>
  <div class="paymentapp">
        <public-title >
            注册门店申请
        </public-title>
         <div class="bg-white load-area">
            <p v-if="total<=0" class="mt-3">当前没有数据</p>
            <div v-else class="el-tables">
                <template>
                <el-table
                    :data="list"
                    border
                    stripe

                    style="width: 100%">
                    <!--表单内容-->
                    <el-table-column v-for="(item,index) in fundsForm" :key="index" :prop="item.prop" :label="item.name" :width="item.width" :min-width="item.minWidth" header-align="center">
                    <!-- 自定义表头 -->
                    <template slot="header" slot-scope="scope">
                        <span>{{ scope.column.label }}</span>
                    </template>
                    <template slot-scope="scope">
                        <!--订单号-->
                        <div class="cursor-pointer pointers" :class="{'text-center':item.center}" v-if="item.pattern==='province'">
                            {{ parseAddress(scope.row) }}
                        </div>
                        <!--时间-->
                        <div :class="{'text-center':item.center}" v-else-if="item.pattern==='time'">{{ scope.row[item.prop]| formatTimestamp(5)}}</div>
                        <!--其他-->
                        <div :class="{'text-center':item.center}" v-else>{{ scope.row[item.prop]}}</div>
                    </template>
                    </el-table-column>
                    <!--操作按钮-->
                    <el-table-column
                    fixed="right"
                    header-align="center"
                    label="操作"
                    width="100">
                    <template slot-scope="scope">
                        <el-dropdown @command="handleCommand($event,scope.row)">
                            <el-button  class="el-dropdown-link text-link" type="text" size="small" style="margin: 0 auto; display: block;">查看<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item  command="1">已处理</el-dropdown-item>
                            <el-dropdown-item  command="2">删除</el-dropdown-item>
                        </el-dropdown-menu>
                        </el-dropdown>
                    </template>
                    </el-table-column>
                </el-table>
                <div class="el-pagination mt-4" >
                    <el-pagination background layout="total,prev, pager, next" 
                        :page-size="10"
                        :total="total" :current-page="Number(formData.page)"
                        @current-change="$GFUN.pageChange"/>
                </div>
                </template>
            </div>
         </div>
  </div>
</template>

<script>
import provinces from '@/assets/utils/provinces'             //省份信息
 import { mapGetters,mapActions,mapState} from 'vuex'
 import { debounce } from "lodash";
export default {
  name: 'PaymentApplication',
  components: {},
  props: {},
  data() {
    return {
        formData:{
            page:1,
            num:10,
        },
        list: [],
        total: 0,
        //搜索条件
        searchCon:{},
        loading: true,
        fundsForm:[
          {name:'申请人姓名',prop:'truename',center:true,width:150},
          {name:'申请人手机号',prop:'mobile',center:true,width:150},
          {name:'门店名称',prop:'title',center:true,minWidth:200},
          {name:'门店电话',prop:'tel',center:true,minWidth:100},
          {name:'门店城市',prop:'province',center:true,minWidth:200,pattern:'province'},
          {name:'详细地址',prop:'address',center:true,minWidth:100},
        ],
        //提交申请弹窗
        count:0,               //倒计时
        currentItem:{},
        ruleForm:{
            id:'',
            action:'',
            uid:'',
        },
        isDisabled:true,
    };
  },
  computed: {
        ...mapState(['newMessageInform']),
        ...mapGetters(['storeInfo', 'userInfo', 'isAdmin', 'isGroup']),
  },
  watch: {  
        newMessageInform(newVal) {
            //收到通知刷新当前页面
            if(newVal.type==62){
                this.initial();
            }
        },
        '$route.query':{
            handler(toVal,fromVal){
                this.formData.page=toVal.page||1
                this.initial();
            },
            immediate:true
        }
  },
  created() {},
  mounted() {},
  methods: {
     ...mapActions(['POST_StoreApplyList','POST_StoreApplyOperate']),
        //初始化
        initial(){
            this.formData={...this.formData,...this.searchCon}
            this.getOrderList();
        },
        getOrderList: debounce(function() {
            this.loading = true;
            this.POST_StoreApplyList({
                data:this.$_Object.removeEmptyProps(this.formData),
                successFun:(res)=>{
                    //如果是酒店待报价合并同一个订单按oid分组合并
                    this.total = res.count;
                    this.loading = false;
                    this.list = res.list;
            }});
        },300),
        /*根据条件搜索订单*/
        getSearchCon(con) {
            this.searchCon = con||{};
            if (this.formData.page == 1) {this.initial()}
            else {
                this.$router.push({
                    name: this.$route.query.name,
                    query: {...this.formData, page: 1}
                })
            };
            
        },
        //点击操作按钮
        handleCommand(command,Itemize) {
            this.revoke(Itemize,command);
        },
        //撤销提交
        revoke(item,command){
            console.log(item);
            this._confirm(command==1?'是否已处理此注册门店申请？':'是否删除此注册门店申请？',async () => {
                this.ruleForm.id = item.id;
                this.ruleForm.uid = item.uid;
                this.ruleForm.action = command;
                this.submitForm();
            });
        },
        //获取本地地址信息
        parseAddress(res){
            let city = provinces.find(item => item.id == res.city);
            let district = provinces.find(item => item.id == res.district);
            return `${city.title}、${district.title}`;
        },
        //提交操作
        submitForm: debounce(function(){
            this.POST_StoreApplyOperate({
                data:this.ruleForm,
                successFun: () => {
                    this._alert('操作成功');
                    this.initial();
                }
            }); 
        },300),
  }
};
</script>

<style>
    .paymentapp .el-dropdown{
        display: flex;
        justify-content: center;
    }
    .pointers{
        display: flex;
        justify-content: center;
    }
</style>
